/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from 'src/shared/app/authentication/component/base/AuthenticationBase.style';

import SupportContactForm from './SupportContactForm';
import messages from 'src/shared/app/authentication/l10n/contactL10n';
import SuccessBanner from 'src/shared/app/base/component/notification/SuccessBanner';
import { loginSupportRoute } from 'src/shared/app/base/route/setting/routeSettings';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import SecondaryTopBar from 'src/shared/app/base/component/template/component/SecondaryTopBar';
import ZIndexTopBar from 'src/shared/app/base/component/template/component/TopBar';
import TopBar, {
  backButton,
} from 'src/shared/app/nav/component/top-bar/TopBar';

type Props = {
  isSupportContacted: boolean,
};

const useStyles = createUseStyles(styles);

const SupportContactSectionDumb = ({
  isSupportContacted,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const [loginSupportPath] = useRoutes(loginSupportRoute);

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const successBannerElt = isSupportContacted ? (
    <SecondaryTopBar>
      <SuccessBanner text={intl.formatMessage(messages.success)} />
    </SecondaryTopBar>
  ) : null;

  return (
    <section className={classes.section}>
      <ZIndexTopBar>
        <TopBar
          title={intl.formatMessage(messages.heading)}
          backTo={loginSupportPath}
          variant={backButton}
        />
      </ZIndexTopBar>
      {successBannerElt}
      <SupportContactForm isSupportContacted={isSupportContacted} />
    </section>
  );
};

export default compose(React.memo)(SupportContactSectionDumb);
